"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrappedSolInstructions = void 0;
const web3_js_1 = require("@solana/web3.js");
const bn_js_1 = __importDefault(require("bn.js"));
const spl_token_1 = require("@solana/spl-token");
const constants_1 = require("./constants");
function wrappedSolInstructions(owner, amount, rentExemption) {
    let totalRequired = amount.add(new bn_js_1.default(rentExemption));
    const wrappedSolAccount = web3_js_1.Keypair.generate();
    const createWrappedSolIxs = [
        web3_js_1.SystemProgram.createAccount({
            fromPubkey: owner,
            newAccountPubkey: wrappedSolAccount.publicKey,
            lamports: totalRequired.toNumber(),
            space: 165,
            programId: constants_1.TOKEN_PROGRAM_PUBLIC_KEY
        }),
        spl_token_1.Token.createInitAccountInstruction(constants_1.TOKEN_PROGRAM_PUBLIC_KEY, constants_1.WRAPPED_SOL_PUBLIC_KEY, wrappedSolAccount.publicKey, owner),
    ];
    const closeTokenIxs = [spl_token_1.Token.createCloseAccountInstruction(constants_1.TOKEN_PROGRAM_PUBLIC_KEY, wrappedSolAccount.publicKey, owner, owner, [])];
    return {
        createWrappedSolIxs,
        closeTokenIxs,
        wrappedSolAccount,
    };
}
exports.wrappedSolInstructions = wrappedSolInstructions;
